module.exports = __webpack_public_path__ + "img/faq-waves.169f4c6a.svg";